import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { useDeviationViewContext } from '../../../Context';
import DefaultViewIcon from '@wix/da-ds/pkg/Icons/DefaultView';
import TheaterViewIcon from '@wix/da-ds/pkg/Icons/TheaterView';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
export const TheaterButton = ({ isTheaterForced, deviation, onClick })=>{
    const { t } = useTranslation();
    const { isTheater } = useDeviationViewContext();
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t(`actionbar.${isTheater ? 'regular' : 'theater'}View${isTheaterForced ? '.disabled' : ''}`)
    }, /*#__PURE__*/ React.createElement(ActionBarButton, {
        onClick: ()=>onClick(deviation),
        disabled: isTheaterForced
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: isTheater ? DefaultViewIcon : TheaterViewIcon
    })));
};
TheaterButton.displayName = 'TheaterButton';
export default TheaterButton;

//# sourceMappingURL=TheaterButton.js.map